import { InfoCard, Link } from '@backstage/core-components';
import { useEntityFromUrl } from '../../../../packages/app/src/hooks/useEntityFromUrl';
import { Box, makeStyles, List, ListItem } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  link: {
    fontSize: '0.85rem',
  },
  wrapperBox: {
    padding: theme.spacing(1),
    paddingBottom: theme.spacing(2),
  },
  contentBox: {
    padding: theme.spacing(1),
    width: '100%',
  },
  cardHeader: {
    '& .MuiCardHeader-title': {
      fontSize: '0.9rem',
      textAlign: 'left',
    },
  },
  listItem: {
    padding: 0,
    paddingLeft: theme.spacing(2),
    position: 'relative',
    '&::before': {
      content: '"•"',
      position: 'absolute',
      left: 0,
      top: '0',
      color: theme.palette.text.primary,
    },
    marginBottom: theme.spacing(0.5),
  },
}));

export const RelatedLinksCard = () => {
  const classes = useStyles();

  const { entity } = useEntityFromUrl();
  const links = entity?.metadata.links;
  if (!links) {
    return <></>;
  }

  return (
    <Box className={classes.wrapperBox}>
      <InfoCard title="Related Links" className={classes.cardHeader}>
        <Box className={classes.contentBox}>
          <List disablePadding>
            {links.map((link, index) => (
              <ListItem key={index} className={classes.listItem} disableGutters>
                <Link to={link.url} className={classes.link}>
                  {link.title}
                </Link>
              </ListItem>
            ))}
          </List>
        </Box>
      </InfoCard>
    </Box>
  );
};
